import { gql } from '@apollo/client';

const Exercise = gql`
  fragment Exercise on Exercise {
    id
    title
    alias
    priority
    visible
    required
    activity
    exerciseProgress {
      id
      testInfo {
        right
        total
        wrong
      }
    }
  }
`;

export default {
  Exercise,
};
